// Pricing Column
import React from "react";
import Money from '../../../lib/Money';
import AgentPriceEditor from "../agents/AgentPriceEditor";

export default function CartItemPrices({item, shoppingCart, callbacks, currentAgent}) {
  const hasSavings = item.extendedSavings && (item.extendedSavings > 0);

  return <div className="col-span-2 text-right pr-2">
    {hasSavings ?
      <ItemPricingDetailWithSavings item={item} currentAgent={currentAgent}/> :
      <ItemPricingDetail item={item} currentAgent={currentAgent}/>}

    {currentAgent && <AgentPriceEditor item={item}
      shoppingCart={shoppingCart} callbacks={callbacks}
      currentAgent={currentAgent}
    />}
  </div>
}

// Prices section at top of pricing column.
// version is used only when there is no discount; see also ItemPricingDetailWithSavings
function ItemPricingDetail({item}) {
  return <div className="whitespace-nowrap text-right">
    <div className="text-lg font-bold">
      {new Money(item.effectiveExtendedPrice).toString()}
    </div>
  </div>
}

// Prices section at top of pricing column.
// version is used only when there is a discount; see also ItemPricingDetail
function ItemPricingDetailWithSavings({item, currentAgent}) {

  const {cataloguePrice, regularUnitPrice} = item;

  return <div className="whitespace-nowrap text-right">
    <div className="line-through">
      {new Money(item.regularExtendedPrice).toString()}
    </div>

    {item.agentExtendedSavings > 0 ?
      <div className="text-sm leading-none">Your private discount:</div> : null}

    <div className="text-orange text-brand-bright">
      - {new Money(item.extendedSavings).toString()}
    </div>

    <div className="text-lg font-bold">
      {new Money(item.effectiveExtendedPrice).toString()}
    </div>
  </div>
}

